import styled from "styled-components";

export const ModalBodyContent = styled.div`  
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

export const TrainingOptionContainer = styled.div`
  height: 105px;
  width: 100%;
  border: 1px solid ${(props) => props.theme.colors.brightGray};
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: oklch(0.97 0.014 254.604);
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 16px;

  & > .icon-highlight {
    width: 48px;
    height: 48px;
  }
    
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 4px;
`;
